export default __webpack_public_path__ + "static/media/video.defbf1bb.webm";